const ERROR_CODES = {
    serverError: 'SERVER_ERROR',
    reactError: 'REACT_ERROR',
    pageNotFoundError: 'PAGE_NOT_FOUND_ERROR',
    nonCriticalCatch: 'NON_CRITICAL_CATCH'
};

export default ERROR_CODES;
